<button (click)="back()" class="fz-35px inline-b" color="primary" mat-icon-button
  matTooltip="{{'common.back' | translate}}">
  <mat-icon>keyboard_arrow_left</mat-icon>
</button>
